"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAmenityIconUploadResultDto = instanceOfAmenityIconUploadResultDto;
exports.AmenityIconUploadResultDtoFromJSON = AmenityIconUploadResultDtoFromJSON;
exports.AmenityIconUploadResultDtoFromJSONTyped = AmenityIconUploadResultDtoFromJSONTyped;
exports.AmenityIconUploadResultDtoToJSON = AmenityIconUploadResultDtoToJSON;
exports.AmenityIconUploadResultDtoToJSONTyped = AmenityIconUploadResultDtoToJSONTyped;
/**
 * Check if a given object implements the AmenityIconUploadResultDto interface.
 */
function instanceOfAmenityIconUploadResultDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    return true;
}
function AmenityIconUploadResultDtoFromJSON(json) {
    return AmenityIconUploadResultDtoFromJSONTyped(json, false);
}
function AmenityIconUploadResultDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'key': json['key'],
    };
}
function AmenityIconUploadResultDtoToJSON(json) {
    return AmenityIconUploadResultDtoToJSONTyped(json, false);
}
function AmenityIconUploadResultDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'key': value['key'],
    };
}
